


















































import { Component, Vue, Prop } from "vue-property-decorator";
import DetalheAtendimentoModel from "@/models/cadastros/saude/DetalheAtendimentoModel";

@Component
export default class DadosAtendimento extends Vue {
  @Prop()
  detalhe!: DetalheAtendimentoModel;
}
